import { useEffect, useRef, useState } from 'react'
import { PiBell, PiBellFill } from 'react-icons/pi'
import { NotificationModal } from './NotificationModal'
import useApiService from 'services/api'
import { useUserAgent } from 'hooks/useUserAgent'
import { MobileNotificationModal } from './MobileNotificationModal'

export const NotificationButton = () => {
  const [show, setShow] = useState(false)
  const [stickRight, setStickRight] = useState(false)
  const api = useApiService()
  const ref = useRef<HTMLDivElement>(null)
  const { isMobile } = useUserAgent()

  useEffect(() => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect()
      if (rect.left + 320 + 20 > window.innerWidth) {
        setStickRight(true)
      } else {
        setStickRight(false)
      }
    }
  }, [ref.current])

  const { data } = api.useGetUnreadNotificationsCount()

  return (
    <div className="click-outside" ref={ref}>
      <div className="relative w-8 h-8">
        <button
          onClick={() => setShow((prev) => !prev)}
          className="w-8 h-8 flex items-center justify-center p-0 rounded-lg border-none cursor-pointer transition-colors duration-150"
          aria-label="Notifications"
          aria-pressed={show}
          data-notification-btn
        >
          {show ? (
            <PiBellFill size={24} className="text-white" />
          ) : (
            <PiBell size={24} className="text-white" />
          )}
        </button>
        {!!data?.count && (
          <div className="absolute -top-0.5 -right-0.5 w-4 h-4 bg-green-300 rounded-full flex items-center justify-center pointer-events-none">
            <span className="text-emerald-900 text-[9px] font-semibold font-['Inter']">
              {data?.count > 99 ? '99+' : data?.count}
            </span>
          </div>
        )}
      </div>
      {show &&
        (isMobile ? (
          <MobileNotificationModal
            onClickOutside={() => setShow(false)}
            clickOutsideClassName=".click-outside"
            stickToRight={stickRight}
          />
        ) : (
          <NotificationModal
            onClickOutside={() => setShow(false)}
            clickOutsideClassName=".click-outside"
            stickToRight={stickRight}
          />
        ))}
    </div>
  )
}
